/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Button, Spinner } from "react-bootstrap";

/**
 * Wraps a standard bootstrap Button component and adds a loading indicator option.
 * It will pass all given params to the Button (except text and isLoading)
 * @param {Object} props
 * @param {Object} props.text button text
 * @param {Object} props.isLoading if true the button will be disabled and a loading spinner displayed
 * @param {Boolean} props.disabled if true the button will be disabled.
 */
export const LoadingButton = ({ text, isLoading, disabled = false, ...other }) => {
	return (
		<Button disabled={disabled || isLoading} {...other}>
			{isLoading ? <Spinner size={other.size || "sm"} animation="border" /> : text}
		</Button>
	);
};
